export default "<p>dispatch-tracking-listview works!</p>\n";